import request, { AxiosResponse } from "axios";
import { apiBase } from "../../constants";

export const registerAccount = async ({
  idToken,
  email,
  timezone,
  source,
  botProtectionToken,
  referralCode,
}: {
  idToken?: string;
  email?: string;
  timezone: string;
  source?: string;
  botProtectionToken?: string;
  referralCode?: string | null;
}) => {
  try {
    const res: AxiosResponse<any> = await request({
      url: `${apiBase}/v1/accounts/`,
      method: "POST",
      data: {
        // send id token in case we are logging in with google
        idToken,
        email,
        source,
        timezone,
        botProtectionToken,
        referral: referralCode,
      },
      withCredentials: true,
      validateStatus: (status) => status < 300,
    });
    return res.data;
  } catch (e) {
    // If we have a specific error message from server throw it.
    const msg =
      e?.response?.data?.error?.message || e.message || "Unknown error. ";
    throw new Error(msg);
  }
};
/**
 * Re-send the signup email-confirmation link. Always resolves (the endpoint
 * stays silent for unknown / already-verified emails), so callers can show a
 * generic "we've resent it" confirmation regardless of the result.
 */
export const resendConfirmation = async (email: string) => {
  await request({
    url: `${apiBase}/v1/accounts/resend-confirmation`,
    method: "POST",
    data: { email },
    withCredentials: true,
    validateStatus: (status) => status < 300,
  });
};

export const setIntialPassword = async (password: string) => {
  try {
    const res: AxiosResponse<any> = await request({
      url: `${apiBase}/v1/accounts/initial-password`,
      method: "POST",
      data: {
        password,
      },
      withCredentials: true,
      validateStatus: (status) => status < 300,
    });
    return res.data;
  } catch (e) {
    // If we have a specific error message from server throw it.
    const msg =
      e?.response?.data?.error?.message || e.message || "Unknown error. ";
    throw new Error(msg);
  }
};
